"use strict";

exports.__esModule = true;
exports.ClassificationContext = void 0;
var _ClassificationController = require("./ClassificationController");
var _Utils = require("../../../Utils");
/**
 * Provides a classification context to consumers
 * @component
 */
var ClassificationContext = exports.ClassificationContext = (0, _Utils.createEnhancedContext)({
  propName: "classification",
  defaultController: _ClassificationController.ClassificationController
});